import 'css-chunksrc/client/pages/documentsPage/reportsPage/reportsList/report/textFields/styles.scss';export default {
  "textFields": "_textFields_1wyxo_1",
  "section": "_section_1wyxo_8",
  "name": "_name_1wyxo_12",
  "content": "_content_1wyxo_18"
};